<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        v-if="id === ''"
        @back="back"
        title
        :content="$t('adicionar-nova-rota')"
      ></el-page-header>
      <el-page-header
        v-if="id !== ''"
        @back="back"
        title
        :content="$t('atualizar-rota')"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="200px"
        v-show="add"
      >
        <el-row :gutter="5">
          <el-col :xs="24" :sm="18" :md="14" :lg="12" :xl="10">
            <el-form-item
              :label="$t('descricao')"
              prop="description"
              class="is-required"
            >
              <el-input
                ref="description"
                v-model="ruleForm.description"
                maxlength="80"
                placeholder="Inserir Descrição da Rota"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="10" :lg="5" :xl="5" :offset="1">
            <el-form-item
              :label="$t('ativa')"
              prop="active"
              class="is-required"
            >
              <el-switch
                v-model="ruleForm.active"
                inactive-color="#ff4949"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="5">
          <el-col :xs="24" :sm="18" :md="14" :lg="12" :xl="10">
            <el-form-item label="Rota por" prop="routeType" class="is-required">
              <el-radio v-model="ruleForm.routeType" label="driver"
                >Motorista</el-radio
              >
              <el-radio v-model="ruleForm.routeType" label="team"
                >Equipe</el-radio
              >
              <el-radio v-model="ruleForm.routeType" label="fleet"
                >Frota</el-radio
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="18" :md="14" :lg="12" :xl="10">
            <el-form-item
              :label="$t('motorista')"
              prop="driver"
              class="infoInput"
            >
              <el-select
                v-model="ruleForm.driver"
                ref="driver"
                clearable
                placeholder="Definir motorista"
                @clear="ruleForm.driver = ''"
              >
                <el-option
                  v-for="item in drivers"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>

              <el-tooltip
                class="item"
                effect="dark"
                content="Define se a rota será exclusiva para um único motorista ou disponível para todos."
                placement="top"
              >
                <i class="el-icon-info"></i>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="18" :md="14" :lg="12" :xl="10">
            <el-form-item label="Rota de" prop="routeOf" class="is-required">
              <el-radio v-model="ruleForm.routeOf" label="collect"
                >Coleta</el-radio
              >
              <el-radio v-model="ruleForm.routeOf" label="delivery"
                >Entrega</el-radio
              >
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="5" v-if="ruleForm.routeOf === 'collect'">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item
              label="Periodicidade"
              prop="period"
              class="is-required"
            >
              <el-checkbox v-model="ruleForm.period.monday" label="monday"
                >Segunda-feira</el-checkbox
              >
              <el-checkbox v-model="ruleForm.period.tuesday" label="monday"
                >Terça-feira</el-checkbox
              >
              <el-checkbox v-model="ruleForm.period.wednesday" label="monday"
                >Quarta-feira</el-checkbox
              >
              <el-checkbox v-model="ruleForm.period.thursday" label="monday"
                >Quinta-feira</el-checkbox
              >
              <el-checkbox v-model="ruleForm.period.friday" label="monday"
                >Sexta-feira</el-checkbox
              >
              <el-checkbox v-model="ruleForm.period.saturday" label="monday"
                >Sábado</el-checkbox
              >
              <el-checkbox v-model="ruleForm.period.sunday" label="monday"
                >Domingo</el-checkbox
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5" v-if="ruleForm.routeOf === 'collect'">
          <el-col :xs="24" :sm="18" :md="14" :lg="12" :xl="10">
            <el-form-item
              :label="$t('horario')"
              prop="time"
              class="infoInput is-required"
            >
              <el-time-select
                v-model="ruleForm.time"
                :picker-options="{
                  start: '06:30',
                  step: '00:15',
                  end: '18:30',
                }"
                placeholder="Select time"
              >
              </el-time-select>
              <el-tooltip
                class="item"
                effect="dark"
                content="Horário que o motorista deve chegar no primeiro cliente"
                placement="top"
              >
                <i class="el-icon-info"></i>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>

        <!--el-row :gutter="5">
          <span class="el-form-item__label">{{ $t("clientes") }}</span>
          <el-col>
            <el-transfer filterable :filter-method="filterCustomer" :filter-placeholder="$t('pesquisar')"
              v-model="selectedCustomers" ref="customers" :data="allCustomers" :titles="['Disponiveis', 'Selecionados']"
              target-order="push" @change="handleSelectCustomer($event)">
            </el-transfer>
          </el-col>
        </el-row>

        <el-row>
          <el-button type="warning" v-if="selectedCustomers.length > 0 && !isVisible" autofocus
            @click="generateRoute()">{{ $t("gerar-rota") }}</el-button>
          <el-button type="warning" autofocus v-if="isVisible" @click="resetRoute()">{{ $t("redefinir-rota")
          }}</el-button>
        </el-row>

        <el-row class="googleMapsWrapper" v-if="isVisible">
          <TravelMap ref="travelMap" class="travel-map" :apiKey="apiKey" :markers="markers" :waypoints="waypoints" />
        </el-row -->
      </el-form>
      <TravelRouter
        v-show="add == false"
        v-if="showTravelMap"
        ref="travelMap"
        class="travel-map"
        @back="add = true"
        @data="routes"
        :markersData="ruleForm.markers"
      />
      <br />
      <el-row justify="center">
        <el-col :span="6">
          <el-button
            type="primary"
            v-if="add == false"
            autofocus
            @click="save('ruleForm')"
          >
            {{ $t("salvar-rota") }}
          </el-button>
          <el-button type="warning" v-else autofocus @click="add = false">
            Definir clientes da rota
          </el-button>
          <el-button @click="back()">{{ $t("voltar") }}</el-button>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { DriversService } from "@/services/customers/drivers.services";
import { RouteService } from "@/services/umov/route.services";

import TravelRouter from "./components/TravelRouter";

export default {
  name: "RouteAdd",
  components: {
    TravelRouter,
  },

  data() {
    return {
      id: "",
      add: true,
      drivers: [],
      showTravelMap: false,
      isVisible: false,
      ruleForm: {
        routeType: "driver",
        routeOf: "collect",
        time: "09:00",
        period: {
          monday: true,
          tuesday: true,
          wednesday: true,
          thursday: true,
          friday: true,
          saturday: false,
          sunday: false,
        },
        description: "",
        active: true,
        driver: "",
        markers: [],
      },
    };
  },
  methods: {
    routes(markers) {
      this.ruleForm.markers = markers;
    },
    back() {
      var vm = this;
      if (vm.add) {
        vm.$router.push({ name: "route" });
      } else vm.add = true;
    },

    get() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      RouteService.getRouteDetails(vm.id)
        .then((res) => {
          vm.ruleForm.description = res.description;
          vm.ruleForm.active = res.route.active;
          vm.ruleForm.position = res.position;
          vm.ruleForm.driver = res.driverId;
          vm.ruleForm.markers = res.route.markers;
          vm.ruleForm.period = res.periods;
          vm.showTravelMap = true;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    getDrivers() {
      const vm = this;

      DriversService.list()
        .then((response) => {
          vm.drivers = response.sort((a, b) => a.name.localeCompare(b.name));
        })
        .catch((error) => {
          return this.$message({
            type: "error",
            duration: 5000,
            message: error,
          });
        });
    },

    save(formName) {
      return this.id ? this.editForm(formName) : this.submitForm(formName);
    },

    submitForm(formName) {
      console.log("chamando submit form");
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);

          RouteService.add(vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("rota-adicionado-sucesso"),
              });
              this.$refs[formName].resetFields();

              setTimeout(() => {
                vm.back();
              }, 1000);
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },

    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);

          RouteService.update(vm.id, vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("rota-atualizado-sucesso"),
              });

              setTimeout(() => {
                vm.back();
              }, 1000);
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },

    filterCustomer(query, item) {
      return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    },
  },

  async mounted() {
    const vm = this;
    if (vm.$route.params.id) {
      vm.id = vm.$route.params.id;

      await vm.get();
      await vm.getDrivers();
    } else {
      await vm.getDrivers();
      vm.$refs.description.$el.children[0].focus();
      vm.ruleForm.driver = "";
      vm.showTravelMap = true;
    }
  },

  computed: {
    mapConfig() {
      return {
        center: { lat: 0, lng: 0 },
      };
    },
  },
};
</script>
<style lang="scss">
.el-page-header__left {
  display: flex !important;
}

.googleMapsWrapper {
  margin-top: 30px;

  span {
    font-size: 18px;
    color: #303133;
  }

  .vue-map-container {
    top: 15px;
  }
}

.infoInput {
  .el-form-item__content {
    display: flex;

    i {
      cursor: pointer;
      color: #f6921e;
      font-size: 20px;
    }
  }
}

.travel-map {
  height: 400px;
}

.actionWrapper {
  .el-button:disabled {
    opacity: 0.6;
  }
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>

